import { useModalStore } from '@features/modal'
import MobileSearchModal from '@features/search/ui/mobile-search-modal'
import styles from '@features/search/ui/mobile-search-modal.module.scss'


export default function useSearchModal () {
  const { openModal, closeModal } = useModalStore()

  const openSearchModal = () => {
    openModal('search', <MobileSearchModal onClose={closeSearchModal} />, {
      hideIconClose: true,
      classes: {
        body: styles.fullscreenBody,
        content: styles.fullscreenContent,
      },
    })
  }

  const closeSearchModal = () => {
    closeModal('search')
  }

  return {
    openSearchModal,
    closeSearchModal,
  }
}
